
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const AddUpcomingCourse = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    isActive: true,
  });

  // ============================================================
  // HANDLE INPUT
  // ============================================================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ============================================================
  // SUBMIT
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Please enter course name.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/upcoming-courses`,
        {
          name: formData.name.trim(),
          isActive: formData.isActive,
        }
      );

      toast.success(
        response.data?.message || "Upcoming course added successfully!",
        {
          position: "top-right",
          autoClose: 2000,
        }
      );

      navigate("/upcoming-courses");
    } catch (error) {
      console.error("Error creating upcoming course:", error);

      toast.error(
        error.response?.data?.message ||
          "Failed to add upcoming course. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // UI
  // ============================================================
  return (
    <div className="w-full mx-auto rounded-lg shadow-md p-6">
      {/* ========================================================
          PAGE HEADING
      ======================================================== */}
      <h1 className="text-3xl sm:text-4xl font-bold text-primaryTextColor mb-4 mt-6">
        Add Upcoming Course
      </h1>

      {/* ========================================================
          FORM
      ======================================================== */}
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* ======================================================
            COURSE INFORMATION
        ====================================================== */}
        <div className="space-y-4">
         

          {/* Course Name */}
          <div>
            <label className="block text-sm font-medium text-secondaryTextColor mb-1">
              Course Name *
            </label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter upcoming course name"
              required
              className="
                w-full
                px-3
                py-2
                border
                border-gray-300
                rounded-md
                focus:outline-none
                focus:ring-2
                focus:ring-secondaryColor
              "
            />
          </div>
        </div>

        {/* ======================================================
            COURSE STATUS
        ====================================================== */}
        <div className="space-y-4">
         

          <div
            className="
              flex
              items-center
              justify-between
              gap-4
              p-4
              border
              border-gray-300
              rounded-md
            "
          >
            <div>
              <p className="text-sm font-medium text-secondaryTextColor">
                Active Status
              </p>

              <p className="text-sm text-secondaryTextColor mt-1">
                Control whether this course is currently active or inactive
              </p>
            </div>

            {/* Toggle */}
            <label className="relative inline-flex items-center cursor-pointer shrink-0">
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                className="sr-only peer"
              />

              <div
                className="
                  w-11
                  h-6
                  bg-gray-300
                  rounded-full
                  peer
                  peer-focus:outline-none
                  peer-focus:ring-2
                  peer-focus:ring-secondaryColor
                  peer-checked:bg-secondaryColor
                  transition-colors
                  duration-200
                  after:content-['']
                  after:absolute
                  after:top-[2px]
                  after:left-[2px]
                  after:bg-white
                  after:rounded-full
                  after:h-5
                  after:w-5
                  after:transition-transform
                  after:duration-200
                  peer-checked:after:translate-x-5
                "
              />
            </label>
          </div>
        </div>

       
        {/* ======================================================
            ACTION BUTTONS
        ====================================================== */}
        <div className="flex flex-col sm:flex-row gap-4 pt-2">
          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="
              flex-1
              px-6
              py-3
              bg-primaryBtnColor
              text-white
              font-medium
              rounded-md
              hover:bg-opacity-90
              transition-opacity
              disabled:bg-gray-400
              disabled:cursor-not-allowed
            "
          >
            {loading ? "Adding Course..." : "Add Course"}
          </button>

          {/* Cancel */}
          <button
            type="button"
            onClick={() => navigate("/upcoming-courses")}
            disabled={loading}
            className="
              px-6
              py-3
              bg-gray-500
              text-white
              font-medium
              rounded-md
              hover:bg-gray-600
              transition-colors
              disabled:opacity-50
              disabled:cursor-not-allowed
            "
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpcomingCourse;

